import { authHeader, handleResponse } from '../helpers'

export const userService = {
  getUsers,
  getUsersByCompany,
  getUser,
  createUser,
  updateUser,
  deleteUser
}

function getUsers() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/users', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var users = response.users
      return users
    })
}

function getUsersByCompany(companyId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/users/company/' + companyId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var users = response.users
      return users
    })
}

function getUser(userId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/user/' + userId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var user = response
      return user
    })
}

function createUser(userData) {
  console.log(userData)
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: userData
  }
  return fetch(process.env.VUE_APP_API_URL + '/user', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var user = response
      return user
    })
}

function updateUser(userId, userData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: userData
  }
  return fetch(process.env.VUE_APP_API_URL + '/user/' + userId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var user = response
      return user
    })
}

function deleteUser(userId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(process.env.VUE_APP_API_URL + '/user/' + userId, requestOptions)
    .then((res) => res.text())
    .then((res) => {
      var user = res
      return user
    })
}
